import { render } from "./JudgeInfo.vue?vue&type=template&id=15912098"
import script from "./JudgeInfo.vue?vue&type=script&lang=js"
export * from "./JudgeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__